import * as React from 'react'
import Payment from '../../../Model/Payment'
import PaymentView from './PaymentView'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject, observer } from 'mobx-react'
import { getFeeSum, getPaymentsSum } from '../../../Helpers/PaymentScheduleHelper'
import * as _ from 'lodash'

export interface IPaymentsViewProps {
    className?: string
    payments: Array<Payment>
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class PaymentsView extends React.Component<IPaymentsViewProps> {
    render() {
        const { className, payments, localizationStore } = this.props
        return (
            <div className={className}>
                <div className="container p-0">
                    <div className="row paymentsLabel">
                        <div className="col-12">
                            <p>{localizationStore!.t!('payments')}</p>
                        </div>
                    </div>
                    <div className="row blockPayments">
                        <div className="col-12">
                            {payments.length === 0 ? <span>{localizationStore!.t!('noPayments')}</span> : ''}
                            {_.orderBy(payments, ['createDate'], ['desc'])
                                .map(x => {
                                    return <PaymentView key={x.id} payment={x} className="border my-1" />
                                })}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 offset-6 text-right">
                            <span>{localizationStore!.t('totalSum')} </span>
                            <mark>{getPaymentsSum(payments)}</mark>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6 offset-6 text-right">
                            <span>{localizationStore!.t('paidFee')} </span>
                            <mark>{getFeeSum(payments)}</mark>
                        </div>
                    </div>
                </div>
            </div>)
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Payment/PaymentsView.tsx